import { render } from "./PageEditorView.vue?vue&type=template&id=c2cb47ee"
import script from "./PageEditorView.vue?vue&type=script&lang=js"
export * from "./PageEditorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__